import {useState} from "react";
import {updateAdditive} from "../../services/Administrative/additiveService";

export const useUpdateAdditive = () => {

    const [updatingAdditive, setUpdatingAdditive] = useState(false);

    const updateExistingAdditive = async (additiveDTO: {}, id: number) => {
        setUpdatingAdditive(true);
        try {
            return await updateAdditive(additiveDTO, id);
        } catch (error:any) {
            throw error
        }
        finally {
            setTimeout(() => {setUpdatingAdditive(false);}, 600)
        }
    };

    return { updateExistingAdditive, updatingAdditive };
};
